$(document).ready(function() {
  /*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
  /*							FANCYBOX						  */
  /*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
  
  /** @type {string} La langue du document */
  const lang = ($('html').attr('lang'));

  $('.fancy, [data-fancybox]').fancybox({
    closeClickOutside: true,
    touch: true,
    loop: true,
    gutter: 30,
    // Internationalization
    // ====================
    lang,
    i18n: {
      en: {
        CLOSE: 'Close',
        NEXT: 'Next',
        PREV: 'Previous',
        ERROR:
          'The requested content cannot be loaded. <br/> Please try again later.',
        PLAY_START: 'Start slideshow',
        PLAY_STOP: 'Pause slideshow',
        FULL_SCREEN: 'Full screen',
        THUMBS: 'Thumbnails',
        DOWNLOAD: 'Download',
        SHARE: 'Share',
        ZOOM: 'Zoom',
      },
	  fr: {
        CLOSE: 'Fermer',
        NEXT: 'Suivant',
        PREV: 'Précédent',
        ERROR:
          'Le contenu demandé ne peut être chargé. <br/> Veuillez réessayer plus tard.',
        PLAY_START: 'Démarrer le slideshow',
        PLAY_STOP: 'Suspendre le slideshow',
        FULL_SCREEN: 'Plein écran',
        THUMBS: 'Miniatures',
        DOWNLOAD: 'Télécharger',
        SHARE: 'Partager',
        ZOOM: 'Zoom',
      },
    },
  });
});
